import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import Immutable from "immutable";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalCreatePresupuesto, guardarPresupuesto } from "../actions";

class ModalCreatePresupuesto extends Component {
  modalContent = () => {
    const buttons = [];
    if (this.props.elementos.filter(x => x === "AXkmoTuy").count())
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="check"
          title="Aceptar"
          disabled={this.props.saving}
        />
      );

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarPresupuesto();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Periodo</label>
                <Input
                  type="number"
                  reducer="cencos"
                  path="modalCreatePresupuesto.data.periodo"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Valor total</label>
                <Input
                  type="number"
                  reducer="cencos"
                  path="modalCreatePresupuesto.data.valor_total"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Valor disponible</label>
                <Input
                  type="number"
                  reducer="cencos"
                  path="modalCreatePresupuesto.data.valor_disponible"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreatePresupuesto } = this.props;
    if (!modalCreatePresupuesto.get("show")) return null;

    return (
      <Modal
        ancho="30vw"
        mostrar={modalCreatePresupuesto.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de presupuestos"
        nombre="modal_create_presupuestos"
        onCerrarModal={() => this.props.showHideModalCreatePresupuesto(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreatePresupuesto: state.cencos.get("modalCreatePresupuesto"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreatePresupuesto,
  guardarPresupuesto
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalCreatePresupuesto);
